import React from 'react';
import CreateUserForm from '../../../components/CreateUserForm';

const AddUser = () => {


    return (<CreateUserForm returnLink={'/admin/gestion_user'} title={'Ajouter un utilisateur'} sendmail={false} />);
};

export default AddUser;